import React from 'react'
import { render } from 'react-dom'

import AppConfig from './config/AppConfig'

//Redux
import { Provider } from 'react-redux'

//Configs
import './config/I18n'
import { store, persistor } from './config/Redux'

//RXjs library include (necessary)
import 'rxjs'

//SVG 4 Everybody
import svg4everybody from 'svg4everybody'

//ServiceWorker (Offline loader)
import * as OfflinePluginRuntime from 'offline-plugin/runtime'
OfflinePluginRuntime.install()

//AWS Amplify
import Amplify from 'aws-amplify';
Amplify.configure({
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  Auth: {
    /*identityPoolId: AppConfig.AMPLIFY_AUTH.identityPoolId,*/
    mandatorySignIn: AppConfig.AMPLIFY_AUTH.mandatorySignIn,
    region: AppConfig.AMPLIFY_AUTH.region,
    userPoolId: AppConfig.AMPLIFY_AUTH.userPoolId,
    userPoolWebClientId: AppConfig.AMPLIFY_AUTH.userPoolWebClientId,
    // TODO: Comment back in when we turn on social sign in
    // oauth: {
    //   domain: AppConfig.AMPLIFY_AUTH.oauth.domain,
    //   redirectSignIn: AppConfig.AMPLIFY_AUTH.oauth.redirectSignIn,
    //   redirectSignOut: AppConfig.AMPLIFY_AUTH.oauth.redirectSignOut,
    //   responseType: AppConfig.AMPLIFY_AUTH.oauth.responseType,
    // },
  },
  /*Analytics: {
    AWSPinpoint: {
      appId: AppConfig.AMPLIFY_PINPOINT.appId,
      region: AppConfig.AMPLIFY_AUTH.region,
    }
  }*/
});

// Google Tag Manager
import initializeGTM from './util/gtm'
initializeGTM();

//Styles
import './style/app.scss'

//App
import App from './components/App'

class AppInstance extends React.Component {
  constructor(props) {
    super(props)

    //SVG 4 Everybody
    svg4everybody()
  }
  render() {
    return (
      <Provider store={store}>
        <App persistor={persistor} />
      </Provider>
    )
  }
}

render(<AppInstance />, document.getElementById('root'))
